import React,
{
    useEffect,
    useState
}
from 'react';
import
{
    navigate
}
from './Router';
import
{
    getMasterVolume,
    setMasterVolume,
    subscribe
}
from './masterVolume';
import './Settings.css';

const PRESET_VOLUMES = [0, 0.2, 0.5, 0.8, 1];

function formatPercent(value)
{
    return `${Math.round(value * 100)}%`;
}

export default function Settings()
{
    const [volume, setVolume] = useState(getMasterVolume());

    useEffect(() => subscribe((next) => setVolume(next)), []);

    const handleSliderChange = (event) =>
    {
        const next = Number(event.target.value) / 100;
        setMasterVolume(next);
    };

    const isMuted = volume <= 0;

    return ( <div className = "settings-page" >
        <div className = "settings-page__backdrop" />
        <div className = "settings-page__shell" >
        <header className = "settings-page__hero" >
        <div className = "settings-page__eyebrow" > Site Settings </div> <h1 className = "settings-page__title" > Tune the whole site from one panel. </h1> <p className = "settings-page__subtitle" >
        This page writes to the shared master volume, so the change sticks across routes and reloads. </p> </header>

        <section className = "settings-card settings-card--volume" >
        <div className = "settings-card__header" >
        <div >
        <div className = "settings-card__label" > Manual Volume </div> <div className = "settings-card__hint" > Persistent global audio level </div> </div> <div className = "settings-volume__value" >
        {
            isMuted ? 'Muted' : formatPercent(volume)
        } </div> </div>

        <div className = "settings-volume__meter"
        aria-hidden = "true" >
        <div className = "settings-volume__meterFill"
        style = {
            {
                width: `${Math.round(volume * 100)}%`
            }
        }
        /> </div>

        <label className = "settings-volume__sliderWrap" >
        <span className = "settings-volume__sliderLabel" > Master volume </span> <input className = "settings-volume__slider"
        type = "range"
        min = "0"
        max = "100"
        step = "10"
        value = {
            Math.round(volume * 100)
        }
        onChange = {
            handleSliderChange
        }
        /> </label>

        <div className = "settings-volume__presets" >
        {
            PRESET_VOLUMES.map((preset) => ( <button key = {
                    preset
                }
                type = "button"
                className = {
                    preset === volume ? 'settings-chip settings-chip--active' : 'settings-chip'
                }
                onClick = {
                    () => setMasterVolume(preset)
                } >
                {
                    preset === 0 ? 'Mute' : formatPercent(preset)
                } </button>
            ))
        } </div>

        <div className = "settings-volume__footer" >
        <span > Keyboard still works too: use - and = anywhere on the site. </span> <span > Saved in this browser
        for future visits. </span> </div> </section>

        <section className = "settings-card settings-card--placeholder" >
        <div className = "settings-card__label" > Future Settings Slot </div> <p className = "settings-card__hint settings-card__hint--block" >
        This layout is ready
        for more controls once you decide what
        else should live in settings. </p> </section>

            <div className = "settings-page__actions" >
            <button type = "button"
        className = "settings-action settings-action--primary"
        onClick = {
            () => navigate('/main')
        } >
        Back to Main </button> <button type = "button"
        className = "settings-action"
        onClick = {
            () => navigate('/')
        } >
        Home </button> </div> </div> </div>
    );
}
